import * as Yup from 'yup';

export const validationSchemaSales = Yup.object().shape({
  salesOwner: Yup.string().required('Sales Owner Is Required'),
  subject: Yup.string()
    .required('Subject Is Required')
    .max(100, 'Subject must be at most 100 characters'),

  accountName: Yup.string().required('Account Name Is Required'),
  saleOrderDetails: Yup.array().of(
    Yup.object().shape({
      productId: Yup.string().required('Product Name is required'),
    })
  ),
  orderDate: Yup.string().required('Order Date is Required'),
  dueDate: Yup.string().required('Due Date is Required'),
});
